var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableChairDSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M5.877 3.6h8.33v6.257h-8.33V3.6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M15.4 10.182a5.218 5.218 0 0 1-5.218 5.218h-.364A5.218 5.218 0 0 1 4.6 10.182c0-.211.17-.382.382-.382h10.036c.211 0 .382.171.382.382Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M3.2 6.534v0a3.301 3.301 0 0 1 3.27-2.845h7.06a3.301 3.301 0 0 1 3.27 2.845v0"
})));
SvgNoTableChairDSelected.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableChairDSelected);
export default ForwardRef;